import { useEffect, useState } from "react";
import DashboardShell from "@/components/DashboardShell";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function AdminKYC() {
  const [list, setList] = useState([]);
  const reload = () => api.get("/admin/kyc").then((r) => setList(r.data));
  useEffect(() => { reload(); }, []);

  const override = async (uid, status) => {
    try { await api.post(`/admin/kyc/${uid}/override`, { status }); toast.success(`Marked ${status}`); reload(); }
    catch (e) { toast.error(formatErr(e?.response?.data?.detail) || e.message); }
  };

  return (
    <DashboardShell title="KYC records" subtitle="Identity verification submissions for parent loan applicants.">
      <div className="card">
        {list.length === 0 ? (
          <p className="text-sm text-[#4F5D4F] py-8 text-center">No KYC records yet.</p>
        ) : (
          <table className="dense">
            <thead><tr><th>Submitted</th><th>User</th><th>Name</th><th>BVN ****</th><th>NIN ****</th><th>DOB</th><th>Provider</th><th>Status</th><th>Action</th></tr></thead>
            <tbody>
              {list.map((k) => (
                <tr key={k.id} data-testid={`kyc-row-${k.user_id}`}>
                  <td>{new Date(k.created_at).toLocaleDateString()}</td>
                  <td className="font-mono text-xs">{k.user_id.slice(0, 8)}</td>
                  <td>{k.full_name_submitted}</td>
                  <td className="font-mono">****{k.bvn_last4}</td>
                  <td className="font-mono">****{k.nin_last4}</td>
                  <td>{k.dob}</td>
                  <td><span className="badge badge-info">{k.provider}</span></td>
                  <td><StatusBadge s={k.status} /></td>
                  <td className="space-x-1">
                    {k.status !== "verified" && <button onClick={() => override(k.user_id, "verified")} className="btn-outline !py-1 !px-2 text-xs" data-testid={`kyc-approve-${k.user_id}`}>Approve</button>}
                    {k.status !== "failed" && <button onClick={() => override(k.user_id, "failed")} className="btn-outline !py-1 !px-2 text-xs" data-testid={`kyc-reject-${k.user_id}`}>Reject</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </DashboardShell>
  );
}

function StatusBadge({ s }) {
  const map = { verified: ["badge-success", "Verified"], failed: ["badge-danger", "Failed"], manual_review: ["badge-warning", "Review"], not_submitted: ["badge-neutral", "Not submitted"] };
  const [c, l] = map[s] || ["badge-neutral", s];
  return <span className={`badge ${c}`}>{l}</span>;
}
